import { useCallback } from 'react';
import { mapDataVizForChartType, trackPageElementClicked } from '../../analytics/utils';
import { BasicTrackingFn, EventParams, SettingsProvider, Params } from '../../types';

const getDataVizValue = (componentSettings: Params): string | undefined => {
  if (!componentSettings.dataViz || componentSettings.dataViz.length === 0) {
    return undefined;
  }
  return componentSettings.dataViz[0];
};

export const useGenAiTracking = (
  trackEvent: BasicTrackingFn,
  componentSettings: Params,
  metadata?: SettingsProvider['metadata']
) => {
  const trackGenAiClicked = useCallback(() => {
    const dataViz = getDataVizValue(componentSettings);
    const elementType = metadata?.tracking?.elementType ?? dataViz;
    const elementName = 'Smart Insights';

    const eventParams: EventParams = {
      elementType,
      chartType: mapDataVizForChartType(dataViz) ?? '',
    };

    trackPageElementClicked(trackEvent, elementName, eventParams);
  }, [trackEvent, componentSettings, metadata]);

  return { trackGenAiClicked };
};
